import { prepareOptionsForDropDown } from 'dedicated/services/summary.service';
import { ALL_OPTIONS } from 'rateCard/constant/constant';
import { FilterOptions, IContentResponse, ITableRow } from 'rateCard/constant/rateCard.interface';

export const mapToTableContent = (records: Array<IContentResponse>): Array<ITableRow> => {
  const rows: Array<ITableRow> = [];
  if (Array.isArray(records)) {
    records.forEach(({ compositeKey: { bandwidth, companyName, serviceType }, rateCards: { arc, otc, uploadDate, status } }) => {
      const row: ITableRow = { bandwidth, serviceType, mediaType: '', contractPeriod: '', otc, arc, uploadDate, status };
      rows.push(row);
    });
  }
  return rows;
};

export const isStandardRate = (records: Array<IContentResponse>): boolean => {
  if (Array.isArray(records) && records.length > 0) {
    return records[0]?.rateCards?.rateCardEnabled;
  }
  return false;
};

export const getFilterOptions = (records: Array<ITableRow>): FilterOptions => {
  const bandwidth = [ALL_OPTIONS].concat(prepareOptionsForDropDown(records, 'bandwidth', null, 'Mbps') as any[]);
  const status = [ALL_OPTIONS].concat(prepareOptionsForDropDown(records, 'status', null) as any[]);
  return { bandwidth, status } as unknown as FilterOptions;
};
